<template>
    <div @click="handleChange" v-if="showFullScreenBtn" class="full-screen-btn-con">
        <Tooltip :content="value ? $_t().main.fullScreenExit :  $_t().main.fullScreen" placement="bottom">
            <Icon :type="value ? 'ios-contract' : 'ios-expand'" :size="23"></Icon>
        </Tooltip>
    </div>
</template>

<script>
export default {
    name: 'fullScreen',
    data() {
        return {
            value: false,
        };
    },
    computed: {
        showFullScreenBtn() {
            return window.navigator.userAgent.indexOf('MSIE') < 0;
        },
    },
    methods: {
        handleFullscreen() {
            let main = document.body;
            if (this.value) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (main.requestFullscreen) {
                    main.requestFullscreen();
                } else if (main.mozRequestFullScreen) {
                    main.mozRequestFullScreen();
                } else if (main.webkitRequestFullScreen) {
                    main.webkitRequestFullScreen();
                } else if (main.msRequestFullscreen) {
                    main.msRequestFullscreen();
                }
            }
            this.value = !this.value;
        },
        handleChange() {
            this.handleFullscreen();
        },
    },
};
</script>
<style lang="less" scoped>
.full-screen-btn-con {
    display: inline-block;
    width: 30px;
    text-align: center;
    cursor: pointer;
    i {
        vertical-align: middle;
    }
}
</style>
